import React, { useState, useEffect } from 'react';
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import Dots from './Dots';
import Rec from './Rec';
import Voice from './Voice';

import stellaImg from '../assets/stella_img.png';
import clientSvg from '../assets/client.svg';
import bulbSvg from '../assets/bulb.svg';
import chatMopar from '../assets/chat_mopar.svg';
import closeSvg from '../assets/close.svg';
import tickSvg from '../assets/tick.svg';
import tickCopilotSvg from '../assets/tick-copilot.svg';
import thumbUpSvg from '../assets/thumb-up.svg';
import thumbDownSvg from '../assets/thumb-down.svg';
import sendSvg from '../assets/send.svg';
import backImg from '../assets/back.svg';
import arrowDown from '../assets/vector.svg'
import { v4 as uuidv4 } from 'uuid';
import { IAutoExceptionTelemetry, IExceptionTelemetry } from '@microsoft/applicationinsights-web';


import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';


type Props = {
    isCopilot: boolean
    setConfigurationHint: Function
}
type ConversationBit = {
    id_chat?: string;
    person: string;
    text?: any;
    url?: string;
    tag?: string;
    audio?: string;
    configuration?: {
        hint?: string;
        image?: string;
    }
};

type RecallCampaign = {
    fca_campaign_number?: string;
    campaign_desc?: string;
    chatbot_available?:boolean;
    is_repaired?:boolean;
    vin_campaign_status?:string;
    type_of_campaign?:string;
    agency_campaign_number?:string;
};

declare global {
    interface Window {
      digitalData: any;
    }
  }

const endpointApi = process.env.REACT_APP_BE; 
//const endpointApi = 'http://localhost:8503';

const carConfiguratorInitiateChat = '/init';
const carConfiguratorAssistant = '/ask';
const carConfiguratorAssistantVoice = 'car-configurator/assistant/voice';
const carConfiguratorResetConversation = 'car-configurator/reset-conversation';

const eSellerAgentRecommendation = 'e-seller/agent-recommendation';
const eSellerTranscription = 'e-seller/transcription';
const eSellerBotText = 'e-seller/bot/text';
const eSellerSentimentText = 'e-seller/sentiment-analysis/text';

const FloatingChatbot = ({ isCopilot, setConfigurationHint }: Props) => {
    const appInsights = useAppInsightsContext();
    const [isConfigurator, setIsConfigurator] = useState<boolean>(false);
    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
    const [isThinking, setIsThinking] = useState<boolean>(false);
    const [isRecording, setIsrecording] = useState<boolean>(false);
    const [inputMessage, setInputMessage] = useState<string>();
    const [conversationContent, setConversationContent] = useState<ConversationBit[]>();
    const [sentiment, setSentiment] = useState<string>();
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState<boolean>(false);
    const [hasVinInserted, setHasVinInserted] = useState<boolean>(false);
    const [vinInputValue, setVinInputValue] = useState('');
    const [isVinFormatValid, setIsVinFormatValid] = useState(true);
    const [chatState, setChatState] = useState({});
    const [idChat, setIdChat] = useState<string>('');
    const [availableCampaigns, setAvailableCampaigns] = useState([{}]);
    const [campaignHasBeenChosen, setCampaignHasBeenChosen] = useState<boolean>(false);
    const [invalidVin, setInvalidVin] = useState<boolean>(false);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(false);
    const [vinList, setVinList] = useState<string[]>([]);
    const [emptyCampaignList, setEmptyCampaignList] = useState<boolean>(false);
    const [errorStatus, setErrorStatus] = useState<boolean>(false);
    //const [ratingIframe, setRatingIframe] = useState<number>(0);
    const [isVinWindowObjectBeCalled, setIsVinWindowObjectBeCalled] = useState<boolean>(false);
    const [showRatingIframe, setShowRatingIframe] = useState<boolean>(false);
    const [sessionId, setSessionId] = useState<string>(uuidv4());
    const [currentCampaign, setCurrentCampaign] = useState<string>('');
    

    
    console.log(process.env.REACT_APP_PUBLIC_URL);
    



    useEffect(() => {
        // -- remove thinking
        // const conversationFiltered = conversationContent?.filter(conversationBit => conversationBit.text !== '…');
        // if (!isThinking && conversationFiltered && conversationFiltered?.toString() !== conversationContent?.toString()) setConversationContent(conversationFiltered);
        // -- reset input
        
        if (inputMessage) setInputMessage('');
        // -- scroll conversation
        const conversationMainElement = document.querySelector('#floating-chatbot .floating-chatbot-conversation-main') as HTMLElement;
        if(conversationMainElement) conversationMainElement.scrollTop = conversationMainElement.scrollHeight;
        // -- set latest
        //
        if(conversationContent && conversationContent.length > 0){
            
            //send metrics every time messages change
           let messageProp = {
               role: conversationContent[conversationContent?.length - 1]?.person,
               message: conversationContent[conversationContent?.length - 1]?.text,
               id_chat: idChat
           }
           console.log(process.env.REACT_APP_TRACKING_ON);
           if(process.env.REACT_APP_TRACKING_ON == 'true'){
               appInsights.trackEvent({ name: 'chat-message', properties: messageProp })
           }
           
       }

    }, [conversationContent]);

    const getVinListFromWindowObject = () =>{
        //read vin list for logged users
        const vinListFromWindow: string[] = (window as any).Mopar?.allGarageVin?.() || [];
        //const vinListFromWindow:string[] = ['1C4HJXDM0MW658958', '1C3CCCCB7FN713500', '1C4HJXDM0MW726756','1C6RR7GM5FS525204','3D7KU28694G106214'];
        console.log('vin list: '+vinListFromWindow);
        if(vinListFromWindow && vinListFromWindow.length > 0){
            setIsUserLoggedIn(true);
            setVinList(vinListFromWindow);
        }
    }

    const formatCampaignsForLog = (campaigns:any) => {
        if(campaigns.length > 0){
            const concatenatedCampaigns = campaigns.map((campaign:any) => {
                return `campaign ${campaign.fca_campaign_number}, ${campaign.campaign_desc}`;
            });        
              return `Campaign viewed: ${concatenatedCampaigns.join(' | ')}`;
        }
        else{
            return '';
        }
      

    }

    const logData = async (logContent:string) =>{
        let logDataHeaders  = {'Content-Type': 'application/json', 'accept': 'application/json'};
        let logData = {"session_id": sessionId, "log_content": logContent };
        let logDataUrl = `${process.env.REACT_APP_BE}/save`;
        console.log(logData);
        try{
            const logDataResponse = await fetchApiData(logDataUrl, 'POST', logDataHeaders, logData );
            console.log(logDataResponse);
        }
        catch(error){console.log('error calling log data');}  
    }

    //generic api method
    const fetchApiData = async (url: string, method: 'GET' | 'POST' = 'GET', headers: Record<string, string> = {}, body: Record<string, any> | null = null) => {
        try {
          const options: RequestInit = {method,
            headers: {
              'Content-Type': 'application/json', // Esempio di header JSON
              ...headers, // Aggiungi gli headers personalizzati, se presenti
            },
            body: null, // Imposta il corpo della richiesta a null per le richieste GET predefinite
          };
      
          if (method === 'POST') {
            // Se è una richiesta POST e un corpo è stato fornito, aggiungilo
            if (body !== null) {
              options.body = JSON.stringify(body);
            }
          }
          const response = await fetch(url, options);
          if (!response.ok) {
            
            let errorTelemetry :IAutoExceptionTelemetry = {
                message: `Error calling service ${response.url}. Status code ${response.status}, Descr: ${response.statusText}`,
                url: 'Component: FloatingChatbot.tsx',
                columnNumber: 0,
                lineNumber: 174,
                error: {
                  api: url,
                  statusCode: response.status,
                  description: response.statusText
                }
                
              }
              appInsights.trackException({exception: errorTelemetry, properties: errorTelemetry.error });



            throw new Error(`Error calling service ${response.url}: Status code ${response.status}, ${response.statusText} `);
            setErrorStatus(true);
          }
      
          const data = await response.json();
          return data;
        } catch (error) {
            setErrorStatus(true);
            console.error('An error occurred:', error);
            // throw error;
        }
      };
      

    const fetchConversation = async (endpoint: string, body?: any) => {
        console.log(window.location.href);
        if (!isThinking) {
            // -- thinking
            setIsThinking(true);
            // -- options
            let requestOptions;
            //-- Manage the fetch in 2 ways, initiate chat and interaction with user
            if (endpoint.includes(carConfiguratorInitiateChat)) {
                //send langCode
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'accept' : 'application/json'
                    },
                    body: JSON.stringify(body),
                }
      
            } else if (endpoint.includes(carConfiguratorAssistant)) {
                let askbody = {
                    "text_input": inputMessage,
                    "chat_state": chatState,
                }
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'accept' : 'application/json'
                    },
                    body: JSON.stringify(askbody),
                }
            }
    
            // -- fetch based on enpoint
            try {
              const response = await fetch(endpoint, requestOptions);
              if(!response.ok){
                //track error on app insights
                let errorTelemetry :IAutoExceptionTelemetry = {
                    message: `Error calling service ${response.url}. Status code ${response.status}, Descr: ${response.statusText}`, url: 'Component: FloatingChatbot.tsx',
                    columnNumber: 0, lineNumber: 234,
                    error: {
                      api: endpoint,
                      statusCode: response.status,
                      description: response.statusText,
                      chat_id: endpoint.includes(carConfiguratorAssistant) ? idChat : null
                    }
                }
                appInsights.trackException({exception: errorTelemetry, properties: errorTelemetry.error });

                
                //set error with code on user
                let errorCallingService = {text_output: 'The chatbot is currently unavailable, please retry later ('+ response.status +')'};
                setIsThinking(false);
                resultConversation(errorCallingService, 'bot');
              }
              else{
                const result = await response.json();
                setIsThinking(false);
                setTimeout(() => {
                    document.getElementById('input-textarea')?.focus();
                }, 500);
                setChatState(result.chat_state);
                setIdChat(result.chat_state.id_chat);
                setCurrentCampaign(result.chat_state.id_recall);
                resultConversation(result, endpoint.includes(eSellerTranscription) ? 'me' : 'bot');
              }
              
              
            } catch (error) {
                //track exception
                let errorTelemetry :IAutoExceptionTelemetry = {
                    message: `Error calling service ${endpoint}, Descr: ${error}`,
                    url: 'Component: AgentChatbot.tsx',
                    columnNumber: 0,
                    lineNumber: 234,
                    error: {
                    api: endpoint,
                    description: `${error}`,
                    chat_id: endpoint.includes('ask') ? idChat : null
                    }
                }
                appInsights.trackException({exception: errorTelemetry, properties: errorTelemetry.error });
                //print error message on screen
                let errorCallingService = {text_output: 'The chatbot is currently unavailable, please retry later'}
                console.error(error);
                setIsThinking(false);
                resultConversation(errorCallingService, 'bot');
            }
            //--- end fetch
        }
    }

    
    const resultConversation = (result: any, person: string) => {
        let hintBits: ConversationBit[] = [];
        let botConversationBit: ConversationBit = {
            id_chat: result?.chat_state?.id_chat,
            person: person,
            text: result?.text_output || result?.answer || result?.detail || result?.recommendation || result?.transcription,
            configuration: {
                hint: result?.configuration?.config,
                image: result?.configuration?.image_url,
            }
        };

        logData(`Chat message: ${botConversationBit.text}, role: ${botConversationBit.person}  timestamp: ${Date.now()}, chatid: ${botConversationBit.id_chat} vin: ${vinInputValue}, campaign: ${result?.chat_state?.id_recall} `);
        if (conversationContent) {
            setConversationContent(conversationContent => [...conversationContent as ConversationBit[], botConversationBit]);
        } else {
            setConversationContent(conversationContent => [botConversationBit]);
        }
    }

    const analyticsDataPush = (event?: string, vinStatus?: string) => {
        let eventName, eventAction, attributes;
        
        switch (event) {
            case "chatWithAi":
                eventName = "chat";
                eventAction = "connect";
                attributes = {
                    linkType: "tool",
                    linkName: "mopar:nav:recalls:chatbot:chat-with-ai"
                };
                break;
            case "startChat":
                eventName = "chat";
                eventAction = "open";
                attributes = {
                    linkName: "mopar:tool:recalls:chatbot:start-chat"
                };
                break;
            case "vinEntered":
                eventName = vinStatus ? "formError" : "formCompletion";
                eventAction = "form";
                attributes = {
                    formName: "vin-chatbot-form",
                    fieldErrors: vinStatus === "invalidVin"
                        ? "invalid-vin-please-try-again"
                        : vinStatus === "emptyCampaign"
                            ? "no-recalls-associated-with-vin"
                            : undefined
                };
                break;
            case "backTo":
                eventName = "generalCTA";
                eventAction = "pageElementInteraction";
                attributes = {
                    linkType: "nav",
                    linkName: hasVinInserted && campaignHasBeenChosen
                        ? "mopar:nav:recalls:chatbot:back-to-recalls-list"
                        : "mopar:nav:recalls:chatbot:back-to-vin-selection"
                };
                break;
            case "learnMore":
                eventName = "generalCTA";
                eventAction = "pageElementInteraction";
                attributes = {
                    linkType: "nav",
                    linkName: "mopar:nav:recalls:chatbot:learn-more-on-mopar"
                };
                break;
                case "close":
                eventName = chatState.hasOwnProperty("chat_history") // check if the chat has been closed with some interaction
                ? "chat"
                : "generalCTA";
                eventAction = chatState.hasOwnProperty("chat_history")
                ? "close"
                : "pageElementInteraction";
                attributes = {
                    linkType: "tool",
                    linkName: "mopar:tool:recalls:chatbot:close-chat-window"
                };
                break;
            default:
                eventName = "generalCTA";
                eventAction = "pageElementInteraction";
                attributes = {
                    linkType: "tool",
                    linkName: "mopar:tool:recalls:chatbot:help-me-with-recall"
                };
                break;
        }
        try {
            if (window.digitalData) {
              window.digitalData.newEvent({
                type: "CustomTagEvent",
                eventName,
                eventAction,
                attributes
              });
            } else {
              console.log("digitalData object not found");
            }
          } catch (e) {
            console.error("An error occurred:", e);
          }          
    };
  
    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
        setShowRatingIframe(false);
         //call vin list when the chatbot has opened
         if(isVinWindowObjectBeCalled === false){
            console.log('vin control bolean', isVinWindowObjectBeCalled);
            getVinListFromWindowObject();setIsVinWindowObjectBeCalled(true);
        }
        if (isCollapsed) analyticsDataPush();
    }

    //manage close bot and show Iframe
    const handleClose = () => {
        //reset the experience, empty input, empty conversation and start the flow from scratch
        setIsCollapsed(!isCollapsed);
        setShowRatingIframe(!showRatingIframe);
        analyticsDataPush("close")
        setHasVinInserted(false);
        setCampaignHasBeenChosen(false);
        setVinInputValue('');
        setConversationContent([]);

    }


    const handleChange = (event: any) => {
        setInputMessage(event.target.value);
        const inputElement = event.target as HTMLInputElement;
        inputElement.style.height = 'auto';
        let textAreaScrollHeight = (inputElement.scrollHeight + 1);
        inputElement.style.height = textAreaScrollHeight + 'px';
    }
    const handleKeyDown = (event: any) => {
        if(event.key === 'Enter') {
            event.preventDefault();
            handleSubmit(event);
        }
    }
    const handleSubmit = (event?: any) => {
        event.preventDefault();
        if (inputMessage && !isThinking) {
            const newConversationBit: ConversationBit = {
                id_chat: idChat,
                person: 'user',
                text: inputMessage
            };
            setConversationContent((conversationContent) => [...conversationContent as ConversationBit[], newConversationBit]);
            logData(`Chat message: ${newConversationBit.text}, role: ${newConversationBit.person} timestamp: ${Date.now()}, chatid: ${idChat} vin: ${vinInputValue}, campaign: ${currentCampaign} `);
            //eseller old call
            //fetchConversation(endpointApi + eSellerBotText, {'text': inputMessage});
            fetchConversation(endpointApi + carConfiguratorAssistant);
        
            const inputElement = event.target[0] || event.target as HTMLInputElement;
            inputElement?.style.removeProperty('height');
        }
    }
    const handleVoice = async (formData: FormData, audioUrl: string) => {
        // -- fetch transcription
        await fetchConversation(endpointApi + eSellerTranscription, formData);
        // -- print audio
        // const newConversationBit: ConversationBit = {
        //     person: 'me',
        //     audio: audioUrl,
        // };
        // setConversationContent(conversationContent => [...conversationContent as ConversationBit[], newConversationBit]);
        // -- fetch recommendation
        setTimeout(() => {
            fetchConversation(isCopilot ? endpointApi + eSellerAgentRecommendation : endpointApi + carConfiguratorAssistantVoice, formData);
        }, 200);
    }
    const handleReset = () => {
        fetchConversation(endpointApi + carConfiguratorResetConversation);
        setIsConfigurator(false);
        setConfigurationHint('');
    }

    const handlePrivacy = () => {
        setPrivacyPolicyAccepted((prevPrivacyPolicyAccepted) => !prevPrivacyPolicyAccepted);
        analyticsDataPush("startChat");
    }

    const handleVinChange = (e:any) =>{
        const vinCurrentValue = e.target.value;
        // Verifica che la lunghezza sia esattamente 17 caratteri alfanumerici
        const isValidFormat = /^[a-zA-Z0-9]{17}$/.test(vinCurrentValue);
        setIsVinFormatValid(isValidFormat);
        setInvalidVin(false);
        setErrorStatus(false);
        setEmptyCampaignList(false);
        setVinInputValue(vinCurrentValue);
    }
    
    const handleVinSubmit  = async (vin:string) => {
        //solo controllo numero caratteri qui
        if (isVinFormatValid) {
            
            logData('Vin inserted: '+vin);
            // Esegui qui l'azione quando il valore è valido
            //qua ci sarà la fetch che mi torna le campagne se è giusto altrimenti bisogna mostrare un messaggio di errore
            let vinLookUpUrl = `${process.env.REACT_APP_BE}/vin-lookup`;
            let vinLookUpPostData = {"vin": vin };
            let vinHeaders  = {'Content-Type': 'application/json', 'accept': 'application/json'};
            try{
                const response = await fetchApiData(vinLookUpUrl,'POST', vinHeaders, vinLookUpPostData);
                
                //VIN OK and have campaings
                if(response.vin_status === 'success' && response.vin_status_desc === ''){
                    
                    let campaignNotRepaired = response.recall_campaigns.filter((campaign:RecallCampaign) => !campaign.is_repaired);
                    let campaignStatus = campaignNotRepaired.filter((campaign:RecallCampaign) => campaign.vin_campaign_status?.toUpperCase() !== "INSPECTED" && campaign.vin_campaign_status?.toUpperCase() !== "REPAIRED")
                    setAvailableCampaigns(campaignStatus);
                    logData(formatCampaignsForLog(campaignStatus));
                    
                    //setAvailableCampaigns([]);
                    if(response.recall_campaigns.length > 0){    
                        setEmptyCampaignList(false);
                        setHasVinInserted(true);
                        setInvalidVin(false);
                        analyticsDataPush("vinEntered")
                    }
                    else{
                        setEmptyCampaignList(true);
                        analyticsDataPush("vinEntered", "emptyCampaign")
                    }
                }
                else if (response.vin_status === 'failure') {
                    if (response.vin_status_desc === 'Your VIN is not involved in any recall campaign') {
                        setEmptyCampaignList(false);
                        setHasVinInserted(true);
                        setInvalidVin(false);
                        setAvailableCampaigns([]);
                        analyticsDataPush("vinEntered", "emptyCampaign")
                    }
                    else {
                        setInvalidVin(true);
                        analyticsDataPush("vinEntered", "invalidVin")
                    }
                } 
            }
            catch(error){
                console.log('error calling VLOOKUP');
            }  
            //let responseVinLookUp = [{fca_campaign_number: 'C44', campaign_desc: 'TRANSMISSION COOLE SUPPLY LINE', chatbot_available: 'true'}, {fca_campaign_number: 'D01', campaign_desc: 'ENGINE DATA LABEL INFORMATION', chatbot_available: 'false'}];
        
        //show lista campagne

        //responsefalse error message
        } else {
        // Esegui qui l'azione quando il valore non è valido
        console.log('Valore non valido:', vinInputValue);
        }
    };

    const handleCampaign = (idCampaign:any, chatbotAvailable:any) =>{
        //if campaign is not in scope redirect
        logData('Campaign clicked: '+idCampaign);
        if(chatbotAvailable == false){
            //js stuff in mopar site
            const vinInputElement = document.getElementById("vin") as HTMLInputElement;
            analyticsDataPush("learnMore");
            if(vinInputElement){
                vinInputElement.value = vinInputValue;
                if(document.getElementById("recall-search-submit")){
                    document.getElementById("recall-search-submit")?.click();
                }               
            }
            else{
                //chiudi bot
                handleToggle();
            }
        }
        else{
             //if campaign is in scope interact with AI
            //resultConversation({message: '…'}, 'bot');
            const initChatBody = {"id_recall": idCampaign};
            fetchConversation(endpointApi + carConfiguratorInitiateChat, initChatBody);
            setCampaignHasBeenChosen(true);
            analyticsDataPush("chatWithAi");     
        } 
    }

  

    //Qua ci predispongo l'inserimento del VIN
    const interactWithCheckbox = (action:string, checkboxId:string)=>{
        window.parent.postMessage({ action: action, id: checkboxId }, '*');
        console.log(action + ' ' + checkboxId);
        // call optional if exist
        if(document.getElementById('id-'+ checkboxId +'-option-checkbox')){
            document.getElementById('id-'+ checkboxId +'-option-checkbox')?.click();
        }
        
        
        
        if (typeof alertFromChatbot === 'function') {
            // La funzione è definita, puoi chiamarla
            alertFromChatbot();
            console.log('called html page function from chatbot');
          } else {
            // La funzione non è definita, gestisci l'errore
            console.log('La funzione alertFromChatbot non è definita in questo contesto');
          }
        
        //alert('activate checkbox A10');
    }

    const parseHtml = (chatMessageWithHtml: string) =>{
         let rendered = <span dangerouslySetInnerHTML={{ __html: chatMessageWithHtml }} />
        return rendered;
    }

    return (
        <>
            <div id="rating-iframe" className={(showRatingIframe ? 'survey-visible' : 'survey-hidden')} style={{ zIndex: showRatingIframe  ? '199999' : '0' }}>
                <button className='rating-iframe-button' onClick={() => setShowRatingIframe(!showRatingIframe) } style={{ backgroundImage: `url(${process.env.REACT_APP_PUBLIC_URL + closeSvg})` }}>
                </button>
                <iframe src={process.env.REACT_APP_IFRAME_URL} sandbox="allow-scripts allow-same-origin"></iframe>
            </div>
            {isCopilot && <div id="sentiment">{sentiment || '...'}</div>}
            <div id="floating-chatbot" className={(isCollapsed && !isCopilot && !isConfigurator ? 'is-collapsed' : '')}>
                <div className={'floating-chatbot-conversation' + (isCollapsed && !isCopilot && !isConfigurator ? ' is-collapsed' : '')}>
                    <header className="floating-chatbot-conversation-header">
                        <button className='minimize' onClick={handleToggle}></button>
                        <button className='close-bot-uc4b' onClick={handleClose} style={{backgroundImage:`url(${process.env.REACT_APP_PUBLIC_URL+closeSvg})`}} ></button>
                        <div className="floating-chatbot-conversation-header-icon" style={{backgroundImage:`url(${process.env.REACT_APP_PUBLIC_URL+stellaImg})`}}></div>
                        <h1>Stella - Intelligent assistant</h1>
                        {/* <button onClick={interactWithCheckbox}>Comunica con html esterno</button> */}
                    </header>
                    <main className="floating-chatbot-conversation-main">
                        {!privacyPolicyAccepted && 
                            <div className='privacy-policy'>
                                <p>By clicking on Start Chatting, I confirm that I have read and understood the <a target='_blank' rel='noreferrer' href='https://www.chrysler.com/crossbrand_us/privacy.html'>Privacy policy</a></p>
                                <button onClick={handlePrivacy}>Start chatting</button>
                            </div>
                        }
                        {(privacyPolicyAccepted && !hasVinInserted) &&
                            <div className='vin-input'>
                                <label htmlFor='vin-input-field'>Hi, I'm Stella, your intelligent assistant. I will help you by providing information about open recall campaigns associated with your vehicle. To help me retrieve the information, please enter your Vehicle Identification Number (VIN) and click Submit.</label>
                                {isUserLoggedIn ?
                                    <select className="vin-select-for-logged-user" onChange={(event) => handleVinChange(event)} style={{backgroundImage:`url(${process.env.REACT_APP_PUBLIC_URL+arrowDown})`}}>
                                        <option value='' disabled selected>Select a VIN</option>
                                        {vinList.map((vin:string, index) => (
                                            <option key={vin} value={vin}>{vin}</option>
                                        ))}
                                    </select> :
                                    <input type='text' className={invalidVin || errorStatus ? 'error' : ''} placeholder='Insert VIN' id='vin-input-field'
                                        value={vinInputValue} onChange={handleVinChange} />
                                }
                                {invalidVin && <span className='invalid-vin'>You entered an invalid VIN, try again.</span>}
                                {errorStatus && <span className='invalid-vin'>Something went wrong. Please try again later.</span>}
                                {!isVinFormatValid && <span className='invalid-vin-format'>The VIN must be 17 characters long</span>}
                                {emptyCampaignList && <span className='invalid-vin-format'>There are no recalls associated with your VIN. Please insert a new one</span>}

                                <button disabled={!vinInputValue || !isVinFormatValid} onClick={() => handleVinSubmit(vinInputValue.toUpperCase())}>Submit</button>
                            </div>
                        }
                        
                        {(hasVinInserted && !campaignHasBeenChosen) && 
                            <div id='campaign-list'>
                                {availableCampaigns.length > 0 && //we have campaigns in list
                                <ul>
                                    <li>
                                        It appears that your vehicle is associated with the below open recall 
                                                {availableCampaigns.length === 1 ? " campaign. " : " campaigns. "}
                                        Please select the one you want to investigate.
                                    </li>                                    
                                    {availableCampaigns && availableCampaigns.map((campaign:RecallCampaign, index) => (
                                        <li key={campaign.fca_campaign_number}>
                                            <div className='campaign-informations'>
                                                <span className='camp-list-title'>{campaign.type_of_campaign} CAMPAIGN {campaign.fca_campaign_number}</span>    
                                                <span>{campaign.campaign_desc}</span>
                                                {campaign.type_of_campaign !== 'WARRANTY EXTENSION' && <span>Status: {campaign.vin_campaign_status}</span>}
                                                <span> {campaign.agency_campaign_number !== '' &&  `NHTSA number: ${campaign.agency_campaign_number} `}</span>  
                                            </div>
                                            {campaign.chatbot_available ?
                                                <a onClick={() => handleCampaign(campaign.fca_campaign_number, campaign.chatbot_available)}>Chat with AI</a>
                                                : isUserLoggedIn ? <p className='camp-list-title'>Information unavailable in this chat. Please select another campaign or check Mopar site</p>
                                                : <a onClick={() => handleCampaign(campaign.fca_campaign_number, campaign.chatbot_available)}>Learn More on Mopar</a>
                                            }

                                        </li>
                                    ))}
                                </ul>
                                }
                                {availableCampaigns.length === 0 && 
                                    <div className='no-campaigns-available'>All good! There are no open campaigns linked to your Vehicle VIN. To check another VIN, please click on Back to VIN Selection</div>
                                }
                                
                            <button className='default-btn back-to-vin-selection' onClick={() => { analyticsDataPush("backTo"); setHasVinInserted(false); setVinInputValue('') }}>Back to vin selection
                            <i className='back-to-vin-icon' style={{ backgroundImage: `url(${process.env.REACT_APP_PUBLIC_URL + backImg})` }}></i></button>
                            </div>

                        }
                        {(privacyPolicyAccepted && hasVinInserted && campaignHasBeenChosen) && conversationContent?.map((bit: ConversationBit, index: number) => (
                            <div id={'conversation-bit-'+ index} key={index} className={'floating-chatbot-message ' + bit.person + (bit.text === '…' ? ' is-thinking' : '') + (bit.audio ? ' voice' : '')}>
                                
                                {/* -- text */}
                                {bit.text === '…' ? <Dots /> : (bit.audio ? <Voice audio={bit.audio} /> : (bit.url ? (<a href={bit.url} target="_blank" rel="noreferrer">{bit.text}</a>) : parseHtml(bit.text) ))} 
                                
                                
                                {/* -- icons */}
                                <div className='tick' style={{backgroundImage:`url(${isCopilot ? tickCopilotSvg : process.env.REACT_APP_PUBLIC_URL+tickSvg})`}}></div>
                               
                            </div>
                        ))}
                        {(privacyPolicyAccepted && hasVinInserted && campaignHasBeenChosen) &&
                            <button onClick={() => { analyticsDataPush("backTo"); setConversationContent([]); setCampaignHasBeenChosen(false) }} className='show-campaigns-btn'>Show campaigns
                             <i className='back-to-vin-icon' style={{ backgroundImage: `url(${process.env.REACT_APP_PUBLIC_URL + backImg})` }}></i></button>
                        }
                         {isThinking && <div id='is-thinking' className='floating-chatbot-message bot is-thinking'><Dots/></div>}
                    </main>
                    {(privacyPolicyAccepted && hasVinInserted && campaignHasBeenChosen) &&  
                        <footer className="floating-chatbot-conversation-input">
                        <form className="floating-chatbot-conversation-input-form" onSubmit={handleSubmit}>
                            <textarea id='input-textarea' className="floating-chatbot-conversation-input-textarea" placeholder={isRecording ? 'I’m listening…' : (isThinking ? 'I’m thinking…' : 'Write something...')} value={isRecording ? '' : inputMessage} rows={1} onChange={handleChange} onKeyDown={handleKeyDown} disabled={isThinking || isRecording}/>
                            <button className="floating-chatbot-conversation-input-submit" type="submit" style={{backgroundImage:`url(${process.env.REACT_APP_PUBLIC_URL+sendSvg})`}} disabled={isThinking}></button>
                        </form>
                        <Rec handleVoice={handleVoice} setIsrecording={setIsrecording} isThinking={isThinking}/>
                        </footer>
                    }
                  
                </div>
                {!isCopilot && (
                    <>
                        <div className={'floating-chatbot-action-container' + (isCollapsed ? ' is-collapsed' : '')}>
                        <label htmlFor="floating-chatbot-action" className={'floating-chatbot-action-label' + (isCollapsed ? '' : ' is-collapsed')}>Help me with recall</label>
                        <button id="floating-chatbot-action" name="floating-chatbot-action" className={'floating-chatbot-action' + (isCollapsed ? '' : ' collapse')} onClick={handleToggle} style={{backgroundImage:`url(${isCollapsed ? process.env.REACT_APP_PUBLIC_URL+chatMopar : process.env.REACT_APP_PUBLIC_URL+closeSvg})`}}></button>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default FloatingChatbot;